import { Component, OnInit } from '@angular/core';
import { ProviderModel } from 'src/models/ProviderModel';
import { ConsolidationModel } from 'src/models/ConsolidationModel';
import { NumAnnoMeseService } from 'src/app/general-services/service-num-anno-mese/num-anno-mese.service';
import { LoaderService } from 'src/app/general-services/service-loader/loader.service';
import { Subscription } from 'rxjs';
import * as toastr from 'toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseGeneralComponent } from 'src/app/BaseGeneralComponent';
import { ConsolidationService } from '../service-consolidation/consolidation.service';
import { Router } from '@angular/router';
import { MessageResponseModel } from 'src/models/MessageResponseModel';
import { timeout } from 'q';

@Component({
  selector: 'app-consolidate-form',
  templateUrl: './consolidate-form.component.html',
  styleUrls: ['./consolidate-form.component.scss']
})
export class ConsolidateFormComponent extends BaseGeneralComponent implements OnInit {

  showProvider: boolean;
  showActions: boolean;
  consolidation: ConsolidationModel;
  saveConsolidation: Subscription;
  registerForm: FormGroup;
  providerSelect: ProviderModel;
  submitted: boolean;

  constructor(private numAnnoMeseService: NumAnnoMeseService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private consolidationService: ConsolidationService,
              private router: Router) {
                super();
                this.showActions = false;
                this.registerForm = this.formBuilder.group({
                  numAnnoMese: [{value: '', disabled: false}, Validators.required],
                  provider: [{value: '', disabled: false}, Validators.required]
                });
                this.providerSelect = new ProviderModel();
                this.consolidation = new ConsolidationModel();
  }

  ngOnInit() {
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }

  getElementSelectedProvider($event) {
    this.consolidation.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });
    this.getLastYearMonthConsolidated($event.row);
  }

  getLastYearMonthConsolidated(provider: ProviderModel) {
    // this.loaderService.display(true);
    this.consolidation.numAnnoMese = '201901';
    this.registerForm.patchValue({
      numAnnoMese: '201901'
    });
    this.saveConsolidation = this.numAnnoMeseService.getConsolidateMonthByProvider(provider)
      .subscribe(
        (result: any) => {
            this.consolidation.numAnnoMese = result;
            this.registerForm.patchValue({
              numAnnoMese: result
            });
            this.loaderService.display(false);
        },
        error => {
          toastr.error('There was a problem, contact the Administrator', 'Error Code');
          this.loaderService.display(false);
        });
  }

  resetProvider() {
    this.consolidation.provider = null;
    this.consolidation.numAnnoMese = null;
    this.providerSelect = new ProviderModel();
    this.registerForm.patchValue({
      provider: null
    });
  }

  confirmConsolidate() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.loaderService.display(true);
      this.saveConsolidation = this.consolidationService.consolidate(this.consolidationService.baseUrl, this.consolidation)
        .subscribe(
          (result: MessageResponseModel) => {
            if (result.responceCode === 1) {
              toastr.success(result.content, 'Success', {timeOut: 0});
              this.loaderService.display(false);
              this.router.navigate([this.LINKS.DASHBOARD], {queryParams: {selectedIndex: 0}});
            } else if (result.responceCode === -1) {
              toastr.warning(result.content, 'Warning', {timeOut: 0});
              this.loaderService.display(false);
            }
          },
          error => {
            toastr.error('Please contact the Administrator', 'System error');
            this.loaderService.display(false);
          });
    }
  }

}
